const { defineMessages } = require('@sm/intl');

const COPY = defineMessages({
  MAIN_HEADING: {
    id: 'Pricing.MainHeading.Heading',
    defaultMessage: 'Choose a plan that works for you',
    desc: '[Type: header][Vis: high] - Primary header for pricing summary page',
  },
  DETAILS_HEADING: {
    id: 'Pricing.DetailsHeading.Heading',
    defaultMessage: 'Compare our full set of features',
    desc: '[Type: header][Vis: high] - Primary header for pricing details page',
  },
  EDUCATIONAL_HEADING: {
    id: 'Pricing.EducationalHeading.Heading',
    defaultMessage: 'Discounts for Students and Educators',
    desc: '[Type: header][Vis: high] - Primary header for pricing educational page',
  },
  EDUCATIONAL_SUBHEADING: {
    id: 'Pricing.EducationalSubHeading.SubHeading',
    defaultMessage:
      'You must have a valid student, staff, or faculty ID to qualify for discounted pricing. Not eligible for this discount?',
    desc: '[Type: header][Vis: high] - Subheader for pricing educational page',
  },
  VIEW_PRICING: {
    id: 'Pricing.ViewPricing.Link',
    defaultMessage: 'View pricing',
    desc: '[Type: Link][Vis: high] - Link to pricing page',
  },
  TEAM_PLANS: {
    id: 'Pricing.Route.TeamPlans',
    defaultMessage: 'Team Plans',
    desc: '[Type: Link][Vis.: high] - A link that will direct the user to the Team Plans Pricing Summary page',
  },
  INDIVIDUAL_PLANS: {
    id: 'Pricing.Route.IndividualPlans',
    defaultMessage: 'Individual Plans',
    desc: '[Type: Link][Vis.: high] - A link that will direct the user to the Individual Plans Pricing Summary page',
  },
  ENTERPRISE: {
    id: 'Pricing.Route.Enterprise',
    defaultMessage: 'Enterprise',
    desc: '[Type: Link][Vis.: high] - A link that will direct the user to the Enterprise Pricing page',
  },
  BACK_TO_SUMMARY: {
    id: 'Pricing.Link.BackToSummary',
    defaultMessage: 'Back to pricing summary',
    desc: '[Type: Link][Vis.: high] - A link that will direct the user to back to the pricing summary page',
  },
  EXPAND_ALL: {
    id: 'Pricing.AccordionToggle.ExpandAll',
    defaultMessage: 'Expand all',
    desc: '[Type: Link][Vis.: high] - A button discription to Expand all accordions',
  },
  COLLAPSE_ALL: {
    id: 'Pricing.AccordionToggle.CollapseAll',
    defaultMessage: 'Collapse all',
    desc: '[Type: Link][Vis.: high] - A button discription to Collapse all accordions',
  },
  BASIC: {
    id: 'Pricing.PackageHeader.Basic',
    defaultMessage: 'Basic',
    desc: '[Type: Heading][Vis.: high] - Basic package name heading',
  },
  STANDARD_MONTHLY: {
    id: 'Pricing.PackageHeader.StandardMonthly',
    defaultMessage: 'Standard Monthly',
    desc: '[Type: Heading][Vis.: high] - Standard Monthly package name heading',
  },
  STANDARD_ANNUAL: {
    id: 'Pricing.PackageHeader.StandardAnnual',
    defaultMessage: 'Standard Annual',
    desc: '[Type: Heading][Vis.: high] - Standard Annual package name heading',
  },
  ADVANTAGE_MONTHLY: {
    id: 'Pricing.PackageHeader.AdvantageMonthly',
    defaultMessage: 'Advantage',
    desc: '[Type: Heading][Vis.: high] - Advantage Monthly package name heading',
  },
  ADVANTAGE_ANNUAL: {
    id: 'Pricing.PackageHeader.AdvantageAnnual',
    defaultMessage: 'Advantage Annual',
    desc: '[Type: Heading][Vis.: high] - Advantage Annual package name heading',
  },
  PREMIER_MONTHLY: {
    id: 'Pricing.PackageHeader.PremierMonthly',
    defaultMessage: 'Premier Monthly',
    desc: '[Type: Heading][Vis.: high] - Premier Monthly package name heading',
  },
  PREMIER_ANNUAL: {
    id: 'Pricing.PackageHeader.PremierAnnual',
    defaultMessage: 'Premier Annual',
    desc: '[Type: Heading][Vis.: high] - Premier Annual package name heading',
  },
  TEAM_ADVANTAGE: {
    id: 'Pricing.PackageHeader.TeamAdvantage',
    defaultMessage: 'Team Advantage',
    desc: '[Type: Heading][Vis.: high] - Team Advantage package name heading',
  },
  TEAM_PREMIER: {
    id: 'Pricing.PackageHeader.TeamPremier',
    defaultMessage: 'Team Premier',
    desc: '[Type: Heading][Vis.: high] - Team Premier package name heading',
  },
  ENT_PLATINUM: {
    id: 'Pricing.PackageHeader.Enterprise',
    defaultMessage: 'Enterprise',
    desc: '[Type: Heading][Vis.: high] - Enterprise package name heading',
  },
  FLEX: {
    id: 'Pricing.PackageHeader.Flex',
    defaultMessage: 'Flex',
    desc: '[Type: Heading][Vis.: high] - Flex package name heading',
  },
});

export default COPY;
